var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1921.52,
    height: 1081.52,
    viewBox: "0 0 1921.52 1081.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20551",
    "data-name": "Group 20551",
    transform: "translate(15351.26 6705.26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 1920,
    height: 1080,
    transform: "translate(-15350.5 -6704.5)",
    fill: "#fff",
    stroke: "#c9daeb",
    strokeWidth: 1.52
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20550",
    "data-name": "Group 20550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20545",
    "data-name": "Group 20545",
    transform: "translate(-15230 -6662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18999",
    "data-name": "Group 18999",
    transform: "translate(1033.397 329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14731",
    "data-name": "Path 14731",
    d: "M701.913,680.152H242a50.816,50.816,0,0,1-50.9-50.9V134.8A50.816,50.816,0,0,1,242,83.9H701.913a50.816,50.816,0,0,1,50.9,50.9V629.253A50.816,50.816,0,0,1,701.913,680.152Z",
    transform: "translate(-141.1 -83.9)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14732",
    "data-name": "Path 14732",
    d: "M264.87,257.142s72.714-109.07,96.346-88.165S499.372,386.209,499.372,386.209L252.6,388.026Z",
    transform: "translate(76.893 208.226)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14733",
    "data-name": "Path 14733",
    d: "M199.5,438.7S340.383,134.208,377.649,152.841c15.451,7.726,53.172,59.08,91.8,115.888C523.076,348.259,578.975,438.7,578.975,438.7",
    transform: "translate(-111.325 157.556)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_320",
    "data-name": "Ellipse 320",
    cx: 64.079,
    cy: 64.079,
    r: 64.079,
    transform: "translate(412.437 251.576) rotate(-76.774)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15660",
    "data-name": "Path 15660",
    d: "M282.008,200.427l-30.52-20.6a1.633,1.633,0,0,0-1.892.014,2.417,2.417,0,0,0-.951,1.981v41.2A2.4,2.4,0,0,0,249.6,225a1.665,1.665,0,0,0,.96.311,1.637,1.637,0,0,0,.932-.292l30.52-20.6a2.538,2.538,0,0,0,0-3.99Z",
    transform: "translate(227.722 1.434)",
    fill: "#c9c9c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20544",
    "data-name": "Group 20544",
    transform: "translate(-232.813 44.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14741",
    "data-name": "Path 14741",
    d: "M185.351,268.994H62.647A40.537,40.537,0,0,1,22.2,228.547h0A40.537,40.537,0,0,1,62.647,188.1h122.7A40.537,40.537,0,0,1,225.8,228.547h0A40.536,40.536,0,0,1,185.351,268.994Z",
    transform: "translate(243.613 611.681)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15656",
    "data-name": "Path 15656",
    d: "M185.351,268.994H62.647A40.537,40.537,0,0,1,22.2,228.547h0A40.537,40.537,0,0,1,62.647,188.1h122.7A40.537,40.537,0,0,1,225.8,228.547h0A40.536,40.536,0,0,1,185.351,268.994Z",
    transform: "translate(487.901 611.679)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 962.765,
    height: 42.914,
    rx: 20,
    transform: "translate(33.076 362)",
    fill: "#c9c9c9",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 962.765,
    height: 42.914,
    rx: 20,
    transform: "translate(33.076 515)",
    fill: "#c9c9c9",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 962.765,
    height: 42.914,
    rx: 20,
    transform: "translate(33.076 668)",
    fill: "#c9c9c9",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 543.576,
    height: 42.914,
    rx: 20,
    transform: "translate(33.076 438)",
    fill: "#c9c9c9",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 543.576,
    height: 42.914,
    rx: 20,
    transform: "translate(33.076 591)",
    fill: "#c9c9c9",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 543.576,
    height: 42.914,
    rx: 20,
    transform: "translate(33 744)",
    fill: "#c9c9c9",
    opacity: 0.14
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 1671,
    height: 208,
    rx: 100,
    transform: "translate(-15226 -6593)",
    opacity: 0.39,
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.c71e51edca0edb140ac6ef0a24c3ce70.svg";
export { ForwardRef as ReactComponent };